import React, { useState } from "react";
import { Table, Button, Modal, Form, Input, Switch, message, Image, Tag } from "antd";
import { PlusOutlined, EditOutlined, DeleteOutlined, PictureOutlined } from "@ant-design/icons";
import "./Banners.css";

function Banners() {
  const [banners, setBanners] = useState([]);
  const [modalOpen, setModalOpen] = useState(false);
  const [editing, setEditing] = useState(null);
  const [imageFile, setImageFile] = useState(null);
  const [preview, setPreview] = useState(null);
  const [form] = Form.useForm();

  const handleAdd = () => {
    setEditing(null);
    setImageFile(null);
    setPreview(null);
    form.resetFields();
    setModalOpen(true);
  };

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setImageFile(file);
      setPreview(URL.createObjectURL(file));
    }
  };

  const handleSubmit = (values) => {
    const banner = {
      ...values,
      id: editing ? editing.id : Date.now(),
      image: preview || editing?.image,
    };
    if (editing) {
      setBanners(banners.map(b => b.id === editing.id ? banner : b));
      message.success("Banner updated");
    } else {
      setBanners([...banners, banner]);
      message.success("Banner added");
    }
    setModalOpen(false);
    form.resetFields();
  };

  const columns = [
    { title: "S.No.", key: "sno", width: 60, render: (_, __, i) => i + 1 },
    {
      title: "Image", dataIndex: "image", key: "image",
      render: (img) => img
        ? <Image src={img} width={80} height={40} style={{ borderRadius: 6, objectFit: "cover" }} />
        : "N/A",
    },
    { title: "Title", dataIndex: "title", key: "title" },
    { title: "Link", dataIndex: "link", key: "link" },
    {
      title: "Status", dataIndex: "is_active", key: "status",
      render: (a) => <Tag color={a ? "green" : "red"}>{a ? "Active" : "Inactive"}</Tag>,
    },
    {
      title: "Action", key: "action",
      render: (_, record) => (
        <div style={{ display: "flex", gap: 8 }}>
          <Button size="small" type="primary" icon={<EditOutlined />}
            style={{ background: "#ff0055", borderColor: "#ff0055" }}
            onClick={() => { setEditing(record); form.setFieldsValue(record); setModalOpen(true); }} />
          <Button size="small" danger icon={<DeleteOutlined />}
            onClick={() => setBanners(banners.filter(b => b.id !== record.id))} />
        </div>
      ),
    },
  ];

  return (
    <div className="banners-page">
      <div className="page-header">
        <div>
          <h2 className="page-title"><PictureOutlined /> Banners</h2>
          <p className="page-subtitle">Total {banners.length} banners</p>
        </div>
        <Button type="primary" icon={<PlusOutlined />}
          style={{ background: "#ff0055", borderColor: "#ff0055" }}
          onClick={handleAdd}>
          Add Banner
        </Button>
      </div>

      {banners.length > 0 && (
        <div className="banners-grid">
          {banners.map(b => (
            <div key={b.id} className="banner-card">
              {b.image && <img src={b.image} alt={b.title} />}
              <div className="banner-info">
                <h4>{b.title}</h4>
                <Tag color={b.is_active ? "green" : "red"}>
                  {b.is_active ? "Active" : "Inactive"}
                </Tag>
              </div>
            </div>
          ))}
        </div>
      )}

      <div className="table-card">
        <Table rowKey="id" columns={columns} dataSource={banners} pagination={{ pageSize: 10 }} />
      </div>

      <Modal
        title={editing ? "Edit Banner" : "Add Banner"}
        open={modalOpen}
        onCancel={() => { setModalOpen(false); form.resetFields(); }}
        footer={null}
      >
        <Form form={form} layout="vertical" onFinish={handleSubmit}>
          <Form.Item name="title" label="Title" rules={[{ required: true }]}>
            <Input placeholder="Banner title" />
          </Form.Item>
          <Form.Item name="link" label="Link URL">
            <Input placeholder="https://..." />
          </Form.Item>
          <Form.Item label="Banner Image">
            <input type="file" accept="image/*" onChange={handleImageChange} />
            {preview && <img src={preview} alt="preview" style={{ marginTop: 10, maxWidth: "100%", borderRadius: 8 }} />}
          </Form.Item>
          <Form.Item name="is_active" label="Active" valuePropName="checked">
            <Switch defaultChecked />
          </Form.Item>
          <div style={{ display: "flex", gap: 10, justifyContent: "flex-end" }}>
            <Button onClick={() => setModalOpen(false)}>Cancel</Button>
            <Button type="primary" htmlType="submit"
              style={{ background: "#ff0055", borderColor: "#ff0055" }}>
              {editing ? "Update" : "Add"}
            </Button>
          </div>
        </Form>
      </Modal>
    </div>
  );
}

export default Banners;